export const microBreakpoint = 300
export const mobileBreakpoint = 769 // px
export const mobileMenuBreakpoint = 1081
export const tabletBreakpoint = 1199
export const productViewBreakpoint = 999
export const desktopBreakpoint = 1920
export const midSizeBreakpoint = 1600
